// qs-ModePanel.vue

<template>
  <div class="mode-panel">
    <span class="mode-name">{{ currentModeName }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useModeManager } from '@/composables/qs-useModeManager'
import { getModeConfig } from '@/types/qs-type-modes'

const modeManager = useModeManager()

const currentModeName = computed(() => {
  const mode = modeManager.activeMode.value
  if (!mode) return 'Draw'

  const config = getModeConfig(mode)
  return config?.name || 'Draw'
})
</script>

<style scoped>
.mode-panel {
  background-color: white;
  border-radius: theme('borderRadius.lg');
  padding: 6px 10px;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mode-name {
  color: #1f2937;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}
</style>
